// BrimLight/common/schemas/collections/videoProjects.js
import { z } from "zod";

const VideoProjectSchema = z.object({
    _id: z.string().optional(),
    subscriptionId: z.string().optional(), 
    name: z.string().min(1, "Project name is required."),
    initialPrompt: z.string().optional().nullable(),
    seriesId: z.string().optional().nullable().describe("The ID of the series this project belongs to."),
        
    status: z.enum([
        "new",
        "story_generating", // This now covers story text AND clip generation
        "story_ready",      // This now means the script is ready for asset generation
        "assets_generating",
        "assets_ready",
        "rendering",
        "complete",
        "failed"
    ]).default("new"),
    finalVideoRelativePath: z.string().optional().nullable(),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default VideoProjectSchema;